export default __webpack_public_path__ + "static/media/dispute.4545e203.svg";